import React from 'react';
import EventsReport from './components/Reports.jsx/eventsReport.js';

function AppReport() {
  return (
    <>
           <EventsReport/>
    </>
  );
}

export default AppReport;
